import {
  OPEN_REVIEW_DIALOG,
  CLOSE_REVIEW_DIALOG,
  DELETE_REVIEW,
  CREATE_REVIEW,
  EDIT_REVIEW,
  REVIEW_REQUEST_ERROR,
  LIKE_REVIEW_TOGGLE,
  LIKE_REVIEW_SUCCESS,
  LIKE_REVIEW_FAILED,
  CREATE_REVIEW_SUCCESS,
  EDIT_REVIEW_SUCCESS,
  DELETE_REVIEW_SUCCESS,
  UPDATE_REVIEW_SUMMARY,
} from '../actions';

export default (state, action) => {
  if (!state) {
    return {
      pendingRequest: false,
      requestError: false,
      created: null,
      edited: null,
      deleted: null,
      updatedSummary: null,
      dialog: {
        openId: null,
      },
    };
  }

  switch (action.type) {
    case CREATE_REVIEW:
      return {
        ...state,
        pendingRequest: { type: 'create' },
        requestError: false,
      };

    case EDIT_REVIEW:
      return {
        ...state,
        pendingRequest: { type: 'edit' },
        requestError: false,
      };

    case DELETE_REVIEW:
      return {
        ...state,
        pendingRequest: { type: 'delete' },
        requestError: false,
      };

    case CREATE_REVIEW_SUCCESS:
      return {
        ...state,
        created: action.review,
        pendingRequest: false,
      };

    case EDIT_REVIEW_SUCCESS:
      return {
        ...state,
        edited: action.review,
        pendingRequest: false,
      };

    case DELETE_REVIEW_SUCCESS:
      return {
        ...state,
        deleted: action.review.id,
        pendingRequest: false,
      };

    case UPDATE_REVIEW_SUMMARY:
      return {
        ...state,
        updatedSummary: action.summary,
      };

    case OPEN_REVIEW_DIALOG:
      return {
        ...state,
        dialog: {
          openId: action.uid,
        },
      };

    case CLOSE_REVIEW_DIALOG:
      return {
        ...state,
        dialog: {
          openId: null,
        },
        requestError: false,
      };

    case REVIEW_REQUEST_ERROR:
      return {
        ...state,
        requestError: true,
        pendingRequest: false,
      };

    case LIKE_REVIEW_TOGGLE:
      return {
        ...state,
        pendingRequest: true,
      };

    case LIKE_REVIEW_SUCCESS:
      return {
        ...state,
        pendingRequest: false,
      };

    case LIKE_REVIEW_FAILED:
      return {
        ...state,
        pendingRequest: false,
      };

    case 'ROUTE_LOADED':
      return {
        ...state,
        edited: null,
        created: null,
      };

    default:
  }

  return state;
};
